<template>
  <RegistroForm />
</template>

<script setup>
import RegistroForm from '../components/RegistroForm.vue';
</script>
